<!-- 1.-Banner inicial "únete a nuestra comunidad -->
<div class="revolution-slider-area slider-bg-1 slider-bg-2 rslider" data-background="#3d088e">
    <div class="revolution-slider slider-bg-2">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner pt--290 pb--170 text-center">
                        <h5 class="heading heading-h5 text-white">ÚNETE A NUESTRA COMUNIDAD</h5>
                        <div class="bkseparator--15"></div>
                        <h2 class="heading heading-h1 text-white font-120">Certificación Internacional<br> NeuroAkashico®</h2>
                        <div class="slider-btn">
                            <a href="/neuroakashico">VER TODOS LOS CURSOS</a>
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="basic-modern-dots white-dots">
                            <div class="dot first-circle"></div>
                            <div class="dot second-circle"></div>
                            <div class="dot third-circle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

